import mList from '_v/common/m-list'
import CAdvSearch from '_v/contract/c-adv-search'
import SelectTags from '_vc/select-tags'
import mContract from './m-contract'

// 合同列表
export default {
    mixins: [mList, mContract],
    components: {
        CAdvSearch,
        SelectTags,
    },
    data() {
        return {
            userNameMap: {},
            support: {
                multiRooms: true,
            },
            enums: {
                RENT_LENGTH: this.$enum.get('RENT_LENGTH'),
                RENT_PAY_METHOD: this.$enum.get('RENT_PAY_METHOD'),
            },
        }
    },
    computed: {
        orderBysList() {
            var list = []
            // prettier-ignore
            if(this.accessName === 'contractRent'){
                list.push(
                    { id: 'endDate asc,houseName asc', text: '综合排序' },
                    { id: 'startDate desc', text: '合同开始时间由近到远' },
                    { id: 'startDate asc', text: '合同开始时间由远到近' },
                    { id: 'endDate asc', text: '合同结束时间由近到远' },
                    { id: 'endDate desc', text: '合同结束时间由远到近' },
                    { id: 'updateTime desc', text: '合同操作时间由近到远' },
                    { id: 'updateTime asc', text: '合同操作时间由远到近' },
                    { id: 'rent desc', text: '租金由大到小' },
                    { id: 'rent asc', text: '租金由小到大' },
                )
            }
            if (this.accessName === 'contractHistory') {
                list.push(
                    { id: 'updateTime desc,houseName asc', text: '综合排序' },
                    { id: 'updateTime desc', text: '合同操作时间由近到远' },
                    { id: 'updateTime asc', text: '合同操作时间由远到近' },
                    { id: 'rent desc', text: '租金由大到小' },
                    { id: 'rent asc', text: '租金由小到大' }
                )
            }
            return list
        },
    },
    methods: {
        // 关闭搜索条件
        onAdvItemClose(item, index) {
            var key = item.key

            // daterange
            if (key.indexOf('-') >= 0) {
                var [k1, k2] = key.split('-')

                this.advFilter[k1] = ''
                this.advFilter[k2] = ''
            }
            // select
            else if (typeof this.advFilter[key] === 'object') {
                this.advFilter[key].splice(index, 1)
            }
            // others
            else {
                this.advFilter[key] = ''
            }

            this.$nextTick(() => this.search())
        },
        // 高级搜索
        onAdvConfirm(val, options) {
            this.advOptions = options
            this.$nextTick(() => this.search())
        },
        // 标准化高级搜索
        normalizeAdvFilter(advFilter) {
            var filter = Object.assign({}, advFilter)

            Object.keys(filter).forEach((k) => {
                switch (k) {
                    case 'contractStatus':
                        if (filter[k].length) {
                            filter[k] = filter[k].join(',')
                        } else {
                            // 在租合同默认取:
                            if (this.accessName === 'contractRent') {
                                filter[k] = '1,2,3,4,5,6,11,27,28,29'
                            }
                            // 历史合同默认取:
                            if (this.accessName === 'contractHistory') {
                                filter[k] = '7,8,9,21,22,23,24,25,26'
                            }
                        }
                        break
                    case 'cusType':
                    case 'createUser':
                        filter[k] = filter[k].join(',')
                        break
                    case 'rentLength':
                        filter[k] = JSON.stringify(
                            filter[k].reduce(
                                (acc, v) => (
                                    acc.push(
                                        this.enums.RENT_LENGTH.getMeta(v).range
                                    ),
                                    acc
                                ),
                                []
                            )
                        )
                        break
                    case 'rentPayMethod':
                        filter[k] = JSON.stringify(
                            filter[k].reduce(
                                (acc, v) => (
                                    acc.push(
                                        this.enums.RENT_PAY_METHOD.getMeta(v)
                                            .range
                                    ),
                                    acc
                                ),
                                []
                            )
                        )
                        break
                }
            })

            return filter
        },
        // 标准化系统用户名称
        normalizeUserName(data) {
            return data.list.reduce((acc, v) => {
                acc[v.id] = v.nickname
                return acc
            }, {})
        },
    },
}
